// Generated from Helpers/DrillBlastEnums.cs, Helpers/Enums.cs, Helpers/TargetImportEnums.cs, Helpers/RegulatoryProfiles.cs, DTOs/DrillBlast/ConsumablesDtos.cs, DTOs/DrillBlast/PatternLifecycleDtos.cs, Helpers/JobFamilies.cs, Messages/EnumNames.cs in MiningwareApi - do not edit.
// Run `npm run gen:enums` after changing one of these enums or JobFamilies.

export enum HoleCategory {
  Production = 0,
  Buffer = 1,
  Trim = 2,
  PreSplit = 3,
  Toe = 4,
  Ramp = 5,
  Pilot = 6,
  Other = 7,
}

export enum BlastCategory {
  Production = 0,
  Ramp = 1,
  Toe = 2,
  Trim = 3,
  PreSplit = 4,
  Other = 5,
}

export enum GeoDrillingCategory {
  GradeControl = 1,
  ReverseCirculation = 2,
  RotaryAirBlast = 3,
  Other = 9,
}

export enum DrillingEntryMode {
  Summary = 0,
  Hole = 1,
}

export enum MeterType {
  Percussion = 1,
  Compressor = 2,
  Rotation = 3,
  Tramming = 4,
}

export enum ServiceStatus {
  Ok = 1,
  DueSoon = 2,
  Overdue = 3,
}

export enum PatternStatus {
  Designed = 0,
  Drilling = 1,
  Drilled = 2,
  Charging = 3,
  Charged = 4,
  Fired = 5,
  Closed = 6,
  Cancelled = 7,
}

export enum PatternShape {
  Square = 0,
  Staggered = 1,
}

export enum InitiationSystem {
  Electronic = 0,
  NonElectric = 1,
  Electric = 2,
  Mixed = 3,
}

export enum DesignSource {
  Manual = 0,
  CsvImport = 1,
  IredesPlan = 2,
  PartnerSystem = 3,
}

export enum HoleStatus {
  Designed = 0,
  Drilled = 1,
  RedrillRequired = 2,
  BackfillRequired = 3,
  Dipped = 4,
  Charged = 5,
  Stemmed = 6,
  Fired = 7,
  Abandoned = 8,
  Misfire = 9,
}

export enum DrillOutcome {
  Complete = 0,
  Short = 1,
  Collapsed = 2,
  Blocked = 3,
  Abandoned = 4,
}

export enum DipCondition {
  Dry = 0,
  Wet = 1,
  Dewatered = 2,
  Collapsed = 3,
  Blocked = 4,
  Cavity = 5,
}

export enum DipAction {
  None = 0,
  Backfill = 1,
  CleanOut = 2,
  Redrill = 3,
  Abandon = 4,
}

export enum WeatherConditions {
  Clear = 0,
  Cloud = 1,
  Rain = 2,
  Storm = 3,
  Fog = 4,
}

export enum MonitorMetric {
  Ppv = 0,
  Airblast = 1,
}

export enum ComplianceWindow {
  CalendarYear = 0,
  LastNBlasts = 1,
}

export enum MisfireTreatment {
  Refire = 0,
  WashOut = 1,
  SupervisedDigOut = 2,
  Other = 3,
}

export enum MisfireStatus {
  Open = 0,
  Cleared = 1,
}

export enum FragmentationMethod {
  Photo = 0,
  Drone = 1,
  ShovelCamera = 2,
  Visual = 3,
}

export enum LicenceKind {
  Shotfirer = 0,
  DpimBlastController = 1,
  MagazineKeeper = 2,
  ExplosivesTransport = 3,
  DrillOperator = 4,
}

export enum MaterialUnit {
  Kg = 0,
  Each = 1,
  Metre = 2,
  Litre = 3,
}

export enum StorageClass {
  Detonator = 0,
  HighExplosive = 1,
  BlastingAgent = 2,
  Oxidiser = 3,
  NonHazardous = 4,
  Stemming = 5,
}

export enum StorageClasses {
  None = 0,
  Detonator = 1,
  HighExplosive = 2,
  BlastingAgent = 4,
  Oxidiser = 8,
  NonHazardous = 16,
  Stemming = 32,
}

export enum StockLocationKind {
  DetonatorMagazine = 0,
  ExplosivesMagazine = 1,
  BulkPrecursorStore = 2,
  Mmu = 3,
  Quarantine = 4,
  ConsumablesStore = 5,
  RigSite = 6,
  Regrind = 7,
}

export enum StockOwnership {
  MineOwned = 0,
  SupplierConsignment = 1,
}

export enum LedgerStatus {
  Posted = 0,
  Parked = 1,
  Discarded = 2,
}

export enum ExplosiveTransactionKind {
  Receipt = 0,
  IssueToBlast = 1,
  ReturnFromBlast = 2,
  Transfer = 3,
  Destruction = 4,
  Adjustment = 5,
  Stocktake = 6,
  Reversal = 7,
}

export enum ConsumableTransactionKind {
  Receipt = 0,
  IssueToRig = 1,
  ReturnFromRig = 2,
  Transfer = 3,
  SentForRegrind = 4,
  ReturnedFromRegrind = 5,
  WriteOff = 6,
  Adjustment = 7,
  Stocktake = 8,
  Reversal = 9,
}

export enum StocktakeStatus {
  Counting = 0,
  PendingApproval = 1,
  Posted = 2,
  Cancelled = 3,
}

export enum ConsumableTrackingMode {
  Serialised = 0,
  Bulk = 1,
}

export enum ConsumableLifeBasis {
  Metres = 0,
  PercussionHours = 1,
  None = 2,
}

export enum ComponentStatus {
  InStock = 0,
  Fitted = 1,
  AtRegrind = 2,
  Scrapped = 3,
  Lost = 4,
}

export enum ComponentEventKind {
  Received = 0,
  Fitted = 1,
  Removed = 2,
  Reground = 3,
  Scrapped = 4,
  LostInHole = 5,
}

export enum PolicyMode {
  Off = 0,
  Warn = 1,
  Block = 2,
}

export enum ValuationMethod {
  Fifo = 0,
  WeightedAverage = 1,
}

export enum DrillBlastModule {
  Meters = 0,
  Consumables = 1,
  ExplosivesStore = 2,
  HoleLevel = 3,
  GradeControl = 4,
  Monitoring = 5,
  BulkPrecursors = 6,
}

export enum DrillBlastSystemOfRecord {
  Eclipse = 0,
  BlastLogic = 1,
}

export enum WorkSheetKind {
  Drill = 0,
  Dip = 1,
  Charge = 2,
}

export enum TargetKind {
  Additive = 0,
  Rate = 1,
  Level = 2,
}

export enum TargetDirection {
  HigherIsBetter = 0,
  LowerIsBetter = 1,
  Band = 2,
  Neutral = 3,
}

export enum JobType {
  None = 0,
  Trucking = 1,
  ProductionTrucking = 2,
  Digging = 4,
  ProductionDigging = 8,
  BlastHoleDrilling = 16,
  ReverseCirculationDrilling = 32,
  HorizontalDrilling = 64,
  FireTruck = 128,
  Breaker = 256,
  Dozer = 512,
  Grader = 1024,
  Loader = 2048,
  WaterTruck = 4096,
  TopHammerDrilling = 8192,
  DthDrilling = 16384,
  RotaryDrilling = 32768,
  ExplosivesLoading = 65536,
}

export enum DetectionSource {
  Manual = 0,
  GpsDerived = 1,
  VendorCode = 2,
  Imported = 3,
}

export enum TargetCategory {
  None = 0,
  Forecast = 1,
  Plan = 2,
  Budget = 3,
  Actuals = 4,
}

export enum DimensionSource {
  NotApplicable = 0,
  Fixed = 1,
  RowLabel = 2,
  ColumnHeader = 3,
  SectionHeader = 4,
}

export enum ImportEntityType {
  Location = 1,
  MaterialType = 2,
  Plant = 3,
  PlantType = 4,
  TargetType = 5,
  Analyte = 6,
  PitStage = 7,
}

export enum ImportRunStatus {
  Success = 1,
  PartialSuccess = 2,
  Failed = 3,
}

export enum DrillBlastSettingType {
  Number = 0,
  Choice = 1,
  Text = 2,
}

export enum ComponentRemovalOutcome {
  ToStore = 0,
  ToRegrind = 1,
  Scrap = 2,
  LostInHole = 3,
}

export enum PatternMoveKind {
  Forward = 0,
  Back = 1,
  Cancel = 2,
  Reopen = 3,
}

export const JobFamilies = {
  Hauling: 3,
  Loading: 2060,
  BlastHoleDrilling: 57360,
  Drilling: 57456,
} as const;

export const LABELLED_ENUMS = {
  BlastCategory,
  ComponentRemovalOutcome,
  ComponentStatus,
  ConsumableTransactionKind,
  DimensionSource,
  DipAction,
  DipCondition,
  DrillOutcome,
  ExplosiveTransactionKind,
  FragmentationMethod,
  HoleCategory,
  HoleStatus,
  ImportEntityType,
  ImportRunStatus,
  InitiationSystem,
  LicenceKind,
  MaterialUnit,
  MeterType,
  MisfireTreatment,
  MonitorMetric,
  PatternShape,
  PatternStatus,
  PolicyMode,
  StockLocationKind,
  StorageClass,
  TargetCategory,
  TargetDirection,
  TargetKind,
  WeatherConditions,
} as const;
